import classNames from "classnames";
import React, { useEffect, useState } from "react";
import {
  Col,
  Form,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import Select from "react-select";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  daysOption,
  priorityOption,
  recurringTypeOptions,
  RelatedToOption,
  TimeOption,
} from "utils/common-options";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FetchPostData, FetchNodePostData } from "utils/common-fetchData";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { checkPermissionsByModule } from "utils/common-helpers";
import { Radio } from "antd";
import Loader from "pages/Separate/Loader";

// Backup
// const GeneralEditTaskTab = React.memo(function GeneralEditTaskTab({
//   getLocations,
//   generalData,
//   tasks,
//   alldependency,
//   verticalActiveTab,
//   onCloseEditModal,
//   toggleLoading,
//   updateData,
//   modalType,
//   relatedvalue,
// }) {
//   const [formRows, setFormRows] = useState([]);
//   const [title, settitle] = useState(null);
//   const [taskOption, setTaskOption] = useState([]);
//   const [location, setLocation] = useState(null);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [assigned, setAssigned] = useState([]);
//   const [est_time, setEstimatedTime] = useState([]);
//   const [priority, setPriority] = useState([]);
//   const [description, setDescription] = useState("");
//   const [related_to, setRelatedTo] = useState([]);
//   const [relatedId, setRelatedId] = useState([]);
//   const [relatedOption, setRelatedOption] = useState([]);
//   const [relatedSelected, setRelatedSelected] = useState([]);
//   const [relatedIdOption, setRelatedIdOption] = useState([]);
//   const [recurring, setRecurring] = useState(false);
//   const [recurringType, setRecuringType] = useState([]);
//   const [recurringDay, setRecurringDay] = useState([]);
//   const [recurringDay1, setRecurringDay1] = useState([]);
//   const [recurringEnd, setRecurringEnd] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tabType, setTabType] = useState("");
//   const tapOption = [
//     {
//       value: 0,
//       label: "General Tab",
//     },
//     {
//       value: 1,
//       label: "Personal Tab",
//     },
//   ];

//   const onDeleteFormRow = (index) => {
//     const newInputs = [...formRows];
//     newInputs.splice(index, 1);
//     setFormRows(newInputs);
//   };

//   const onAddFormRow = () => {
//     setFormRows([
//       ...formRows,
//       { task_name: "", task_assign: null, task_status: 0, sub_enddate: "" },
//     ]);
//   };

//   const handleInputChange = (key, event) => {
//     const { name, value } = event?.target;
//     const updatedFormRows = formRows.map((row, index) =>
//       index === key ? { ...row, [name]: value } : row,
//     );
//     setFormRows(updatedFormRows);
//   };

//   const handleSelectChange = (key, selectedOption) => {
//     const updatedFormRows = formRows.map((row, index) =>
//       index === key ? { ...row, task_assign: selectedOption } : row,
//     );
//     setFormRows(updatedFormRows);
//   };

//   const handleEndChange = (key, e) => {
//     const updatedFormRows = formRows.map((row, index) =>
//       index === key ? { ...row, sub_enddate: e } : row,
//     );
//     setFormRows(updatedFormRows);
//   };

//   const handleCheckboxChange = (key) => {
//     const updatedRows = formRows.map((person, index) => {
//       if (index === key) {
//         return {
//           ...person,
//           task_status: person.task_status === 1 ? 0 : 1,
//         };
//       }
//       return person;
//     });
//     setFormRows(updatedRows);
//   };

//   useEffect(() => {
//     // Recurring
//     setRecurring(generalData?.recurring == 1 ? true : false);
//     setRecuringType(
//       recurringTypeOptions?.find(
//         (obj) => obj?.value == generalData?.recurring_type,
//       ),
//     );
//     setTabType(generalData?.tab_type);
//     setRecurringEnd(generalData?.recurring_enddate);
//     setRecurringDay1(generalData?.recurring_days);
//     const selectDay = generalData?.recurring_days?.split(",");
//     setRecurringDay(
//       daysOption?.filter((item) => selectDay?.includes(item.value)),
//     );

//     // General Data
//     setLocation(
//       getLocations?.find((loc) => loc.value == generalData?.location),
//     );
//     setStartDate(generalData?.startdate);
//     setEndDate(generalData?.enddate);
//     setDescription(generalData?.description || "");
//     setPriority(
//       priorityOption?.find((pro) => pro.value == generalData?.priorty),
//     );
//     const task = tasks?.find((obj) => obj.value == generalData?.title);
//     settitle(generalData?.title);
//     setTaskOption(tasks?.filter((obj) => obj?.related == generalData?.related));
//     const ids = generalData?.assigned?.split(",").map(Number);
//     const assignee = alldependency?.users?.filter((item) =>
//       ids?.includes(item.value),
//     );
//     setAssigned(assignee);
//     const relatedOption = RelatedToOption?.find(
//       (rel) => rel.value == generalData?.related,
//     );
//     setRelatedSelected(relatedOption);
//     setRelatedOption(relatedOption?.related);
//     const realtedTo = relatedOption?.related?.find(
//       (obj) => obj.value == generalData?.related_to,
//     );
//     setRelatedTo(realtedTo);
//     setEstimatedTime(
//       TimeOption?.find((obj) => obj.value == generalData?.estimate_time),
//     );
//     const relatedOptions =
//       realtedTo?.value == "lead"
//         ? alldependency?.leads
//         : realtedTo?.value == "proposal"
//         ? alldependency?.proposal
//         : realtedTo?.value == "digital-project"
//         ? alldependency?.digital_projects
//         : realtedTo?.value == "development-project"
//         ? alldependency?.projects
//         : realtedTo?.value == "introducer"
//         ? alldependency.introducer
//         : realtedTo?.value == "staff"
//         ? alldependency.staff
//         : realtedTo?.value == "expense" || realtedTo?.value == "credit-card"
//         ? alldependency?.expense
//         : realtedTo?.value == "invoice"
//         ? [...alldependency?.digital_projects, ...alldependency?.projects]
//         : [];
//     setRelatedIdOption(relatedOptions);
//     setRelatedId(
//       relatedOptions?.find((obj) => obj.value == generalData?.related_id),
//     );
//     if (generalData?.subtasks?.length == 0) {
//       if (task != undefined && task?.subtasks != null) {
//         // const sub = task?.subtasks?.split("#@");
//         const sub = task?.subtasks?.split("@#");
//         setFormRows(
//           sub?.map((obj) => ({
//             task_name: obj,
//             task_assign: null,
//             task_status: 0,
//             sub_enddate: "",
//           })),
//         );
//       } else {
//         setFormRows([]);
//       }
//     } else {
//       setFormRows(
//         generalData?.subtasks?.map((obj) => ({
//           task_name: obj?.title,
//           task_id: obj?.id,
//           task_assign:
//             alldependency?.users?.find((user) => user.value == obj?.assign) ||
//             null,
//           task_status: obj?.status,
//           sub_enddate: obj?.enddate === "-" ? "" : obj?.enddate,
//         })),
//       );
//     }
//   }, [generalData]);

//   useEffect(() => {
//     if (Object.keys(relatedvalue).length != 0) {
//       const related = RelatedToOption?.find(
//         (obj) => obj.id == verticalActiveTab,
//       );
//       setRelatedOption(related?.related);
//       setRelatedSelected(related);
//       setRelatedId([]);
//       setRelatedIdOption([]);
//       setRelatedTo([]);
//       setTaskOption(
//         tasks?.filter((obj) => obj?.related == relatedvalue?.value),
//       );
//       settitle([]);
//       setFormRows([]);
//     }
//   }, [relatedvalue]);

//   const onHandleEdit = async (e) => {
//     e.preventDefault();
//     const subtask_id = formRows?.some((item) => item.hasOwnProperty("task_id"));
//     const formDatas = {
//       tab_type: tabType || 0,
//       general_id: generalData?.id,
//       user_id: localStorage.getItem("auth_id"),
//       location: location?.value,
//       title: title,
//       startdate: startDate,
//       enddate: endDate,
//       assigned: assigned?.map((obj) => obj.value)?.join(","),
//       priority: priority?.value,
//       related: relatedSelected?.value,
//       related_to: related_to?.value,
//       related_id: relatedId?.value,
//       est_time: est_time?.value,
//       description: description,
//       subtask: formRows?.map((obj) => obj?.task_name)?.join("@#"),
//       subtask_assign: formRows
//         ?.map((obj) => obj?.task_assign?.value)
//         ?.join(","),
//       subtask_status: formRows?.map((obj) => obj?.task_status)?.join(","),
//       sub_enddate: formRows?.map((obj) => obj?.sub_enddate)?.join(","),
//       edit_status: subtask_id ? 1 : 0,
//       subtask_id: subtask_id
//         ? formRows?.map((obj) => obj?.task_id)?.join(",")
//         : "",
//       recurring: recurring ? 1 : 0,
//       recurring_type: recurringType?.value,
//       recurring_days:
//         recurringType?.value == "daily"
//           ? null
//           : recurringType?.value == "monthly"
//           ? moment(recurringDay1).format("DD")
//           : recurringType?.value == "weekly"
//           ? recurringDay?.map((obj) => obj.value)?.join(",")
//           : null,
//       recurring_enddate: recurringEnd,
//     };
//     const response = await FetchPostData(
//       toggleLoading,
//       "editGeneralTasks",
//       secureLocalStorage.getItem("auth_token"),
//       formDatas,
//     );
//     if (response?.data?.success) {
//       Swal.fire({
//         icon: "success",
//         text: "Task edited successfully.",
//       }).then(() => {
//         onCloseEditModal();
//         updateData(response?.data?.data?.tasks[0], "edit");
//       });
//     }
//     setLoading(false);
//   };

//   console.log("generalData", generalData);

//   return (
//     <div>
//       {loading && <Loader />}

//       <div className="text-end add-task-button d-flex gap-2 align-items-center">
//         {localStorage?.getItem("auth_id") == 32 ||
//         localStorage?.getItem("auth_id") == 1 ||
//         localStorage?.getItem("auth_id") == 4 ? (
//           <div className="me-5 radio-antd">
//             <Radio.Group
//               value={tabType}
//               options={tapOption}
//               onChange={(e) => {
//                 setTabType(e.target.value);
//               }}
//             />
//           </div>
//         ) : null}
//         <h5 className="text-purple mb-0">
//           Created by :{" "}
//           <span className="text-primary">
//             <strong>{generalData?.added_by_name}</strong>
//           </span>
//         </h5>
//         {modalType != "view" && (
//           <button
//             type="submit"
//             className="btn ms-md-2 btn-save btn-label"
//             onClick={onHandleEdit}
//           >
//             <i className="fas fa-save me-1 label-icon"></i> Save
//           </button>
//         )}
//         <button
//           type="button"
//           onClick={(e) => {
//             e.preventDefault();
//             onCloseEditModal();
//           }}
//           className="btn ms-md-2 btn-red btn-label"
//         >
//           <i className="dripicons-cross me-2 icon-center label-icon"></i>
//           CANCEL
//         </button>
//       </div>
//       <Row>
//         <div className="col-md-12 d-flex flex-column new-dashboard-task-modal bg-white">
//           <div className="col-12 form-container mt-2">
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <Form className="row d-flex justify-content-center align-items-center">
//                 <div className="col-md-12 d-flex flex-column new-task-modal">
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                     <div className="col-sm-3 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Location <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Location"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         options={getLocations}
//                         value={location}
//                         onChange={(e) => setLocation(e)}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-9 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Task Name <span className="text-danger">*</span>
//                       </Label>
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter Task Name"
//                         value={title}
//                         onChange={(e) => settitle(e.target.value)}
//                         disabled={modalType == "view"}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                     <div className="col-md-2 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Start Date
//                       </Label>
//                       <Input
//                         type="date"
//                         className="form-control"
//                         placeholder="Select Date"
//                         value={startDate}
//                         onChange={(e) => setStartDate(e.target.value)}
//                         disabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-2 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">End Date</Label>
//                       <Input
//                         type="date"
//                         className="form-control"
//                         placeholder="Select Date"
//                         value={endDate}
//                         onChange={(e) => setEndDate(e.target.value)}
//                         disabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-2 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Estimated Time <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Time"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         options={TimeOption}
//                         value={est_time}
//                         onChange={(e) => setEstimatedTime(e)}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-6 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Assignee <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Member"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         isMulti
//                         options={alldependency?.users}
//                         value={assigned}
//                         onChange={(e) => setAssigned(e)}
//                         closeMenuOnSelect={false}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                     <div className="col-md-3 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Priority <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Priority"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         value={priority}
//                         options={priorityOption}
//                         onChange={(e) => setPriority(e)}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                     {relatedOption?.length != 0 && (
//                       <div className="col-md-2 ps-2">
//                         <label htmlFor="sales-dropdown">
//                           {relatedSelected?.label}
//                         </label>
//                         <Select
//                           placeholder={`Select ${relatedSelected?.label}`}
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={relatedOption}
//                           value={related_to}
//                           onChange={(selectedOption) => {
//                             setRelatedTo(selectedOption);
//                             const relatedOptions =
//                               selectedOption?.value == "lead"
//                                 ? alldependency?.leads
//                                 : selectedOption?.value == "proposal"
//                                 ? alldependency?.proposal
//                                 : selectedOption?.value == "digital-project"
//                                 ? alldependency?.digital_projects
//                                 : selectedOption?.value == "development-project"
//                                 ? alldependency?.projects
//                                 : selectedOption?.value == "introducer"
//                                 ? alldependency.introducer
//                                 : selectedOption?.value == "staff"
//                                 ? alldependency.staff
//                                 : selectedOption?.value == "expense" ||
//                                   selectedOption?.value == "credit-card"
//                                 ? alldependency?.expense
//                                 : selectedOption?.value == "invoice"
//                                 ? [
//                                     ...alldependency?.digital_projects,
//                                     ...alldependency?.projects,
//                                   ]
//                                 : [];
//                             setRelatedIdOption(relatedOptions);
//                           }}
//                           isDisabled={modalType == "view"}
//                         />
//                       </div>
//                     )}
//                     {relatedIdOption?.length != 0 && (
//                       <div className="col-md-2 ps-2">
//                         <label htmlFor="lead-dropdown">
//                           {related_to?.label}
//                         </label>
//                         <Select
//                           placeholder={`Select ${related_to?.label}`}
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={relatedIdOption}
//                           value={relatedId}
//                           onChange={(e) => {
//                             setRelatedId(e);
//                           }}
//                           isDisabled={modalType == "view"}
//                         />
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-start">
//                     <div className="col-md-2 mb-3">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Recurring Task
//                       </Label>
//                       <div className="form-switch form-switch-md mb-2 ps-5">
//                         <input
//                           title="Recurring Task"
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customSwitchsizemd"
//                           checked={recurring}
//                           onChange={(e) => setRecurring(e.target.checked)}
//                           disabled={modalType == "view"}
//                         />
//                       </div>
//                     </div>
//                     {recurring ? (
//                       <>
//                         <div className="col-md-3 ps-2">
//                           <Label htmlFor="formrow-firstname-Input">
//                             Recurring Type
//                           </Label>
//                           <Select
//                             placeholder="Select Recurring Type"
//                             className="basic-multi-select"
//                             classNamePrefix="select"
//                             options={recurringTypeOptions}
//                             value={recurringType}
//                             onChange={(e) => setRecuringType(e)}
//                             isDisabled={modalType == "view"}
//                           />
//                         </div>
//                         {recurringType?.value == "weekly" ? (
//                           <div className="col-md-5 ps-2">
//                             <Label htmlFor="formrow-firstname-Input">
//                               Select Days
//                             </Label>
//                             <Select
//                               placeholder="Select Days"
//                               className="basic-multi-select"
//                               classNamePrefix="select"
//                               options={daysOption}
//                               isMulti
//                               value={recurringDay}
//                               onChange={(e) => setRecurringDay(e)}
//                               isDisabled={modalType == "view"}
//                             />
//                           </div>
//                         ) : recurringType?.value == "monthly" ? (
//                           <div className="col-md-3 ps-2">
//                             <Label htmlFor="formrow-firstname-Input">
//                               Select Date
//                             </Label>
//                             <Input
//                               type="date"
//                               className="form-control"
//                               placeholder="Select Date"
//                               value={recurringDay1}
//                               onChange={(e) => setRecurringDay1(e.target.value)}
//                               disabled={modalType == "view"}
//                             />
//                           </div>
//                         ) : null}
//                         <div className="col-md-2 ps-2">
//                           <Label htmlFor="formrow-firstname-Input">
//                             Recurring End Date
//                           </Label>
//                           <Input
//                             type="date"
//                             className="form-control"
//                             placeholder="Select Date"
//                             value={recurringEnd}
//                             onChange={(e) => setRecurringEnd(e.target.value)}
//                             disabled={modalType == "view"}
//                           />
//                         </div>
//                       </>
//                     ) : null}
//                   </div>
//                   {recurring && recurringType?.value == "daily" ? (
//                     <div className="ps-2 text-danger mb-3">
//                       *A new task will be assigned daily through this feature,
//                       with the expectation that it will be completed on daily
//                       purpose.
//                     </div>
//                   ) : recurring && recurringType?.value == "weekly" ? (
//                     <div className="ps-2 text-danger mb-3">
//                       * This feature will create tasks on the selected weekdays,
//                       which are expected to be completed on selected weekdays
//                     </div>
//                   ) : recurring && recurringType?.value == "monthly" ? (
//                     <div className="ps-2 text-danger mb-3">
//                       * This feature will generate a new task every month on the
//                       selected date, which need to be completed on selected
//                       month day.
//                     </div>
//                   ) : null}

//                   <div className="col-12 pe-2 form-container mt-2 ms-2">
//                     <Row className="bg-white px-2 py-2 mt-0 shadow-md mb-3 me-5">
//                       {modalType != "view" && (
//                         <div className="d-flex justify-content-end align-items-end px-0 ms-3">
//                           <div className="text-end mb-0">
//                             <button
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 onAddFormRow();
//                               }}
//                               className="btn btn-purple"
//                             >
//                               <i className="fas fa-plus me-2"></i>
//                               Add Subtask
//                             </button>
//                           </div>
//                         </div>
//                       )}
//                       {formRows?.map((person, key) => (
//                         <div key={key} className="">
//                           <div className="d-flex">
//                             <div className="contact-form d-flex col-md-11">
//                               <div className="custim-width contact-btns ml-10 d-flex justify-content-center align-items-center mb-md-0 mt-3">
//                                 <div className="text-end" id="customCheckbox">
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input custom-checkbox mt-2"
//                                     id={`customCheck-outlinecolor2-${key}`}
//                                     checked={person?.task_status == 1}
//                                     disabled={
//                                       // generalData.added_by != localStorage.getItem("auth_id") ||
//                                       person?.task_assign?.value !=
//                                         localStorage.getItem("auth_id") ||
//                                       modalType == "view"
//                                     }
//                                     onChange={() => handleCheckboxChange(key)}
//                                   />
//                                 </div>
//                               </div>
//                               <div className="contact-column edit-contact-column mb-md-0 col-7">
//                                 <label htmlFor="">Subtask Name</label>
//                                 <input
//                                   type="text"
//                                   name="task_name"
//                                   placeholder="Enter Subtask Name"
//                                   className="form-control"
//                                   value={person?.task_name}
//                                   onChange={(e) => handleInputChange(key, e)}
//                                   disabled={modalType == "view"}
//                                 />
//                               </div>
//                               <div className="contact-column edit-contact-column mb-md-0 col-3">
//                                 <label htmlFor="">Assignee</label>
//                                 <Select
//                                   placeholder="Select Member"
//                                   className="basic-multi-select"
//                                   classNamePrefix="select"
//                                   name="task_assign"
//                                   options={alldependency?.users}
//                                   value={person?.task_assign}
//                                   onChange={(selectedOption) =>
//                                     handleSelectChange(key, selectedOption)
//                                   }
//                                   isDisabled={modalType == "view"}
//                                 />
//                               </div>
//                               <div className="contact-column edit-contact-column mb-md-0 col-2">
//                                 <label htmlFor="">End Date</label>
//                                 <input
//                                   type="date"
//                                   name="sub_enddate"
//                                   className="form-control"
//                                   value={person?.sub_enddate}
//                                   onChange={(e) =>
//                                     handleEndChange(key, e.target.value)
//                                   }
//                                   disabled={modalType == "view"}
//                                 />
//                               </div>
//                             </div>
//                             <div className="col-md-1 contact-btns ml-10 d-flex justify-content-end align-items-end mb-md-0 ms-4">
//                               <div className="text-end">
//                                 {modalType != "view" && (
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       onDeleteFormRow(key);
//                                     }}
//                                     className="btn btn-red"
//                                   >
//                                     <i className="fas fa-trash-alt"></i>
//                                   </button>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                           {key !== formRows.length - 1 ? (
//                             <div className="border-bottom my-3"></div>
//                           ) : null}
//                         </div>
//                       ))}
//                     </Row>
//                   </div>

//                   <div className="col-md-12 d-flex mb-0 justify-content-start align-items-end flex-column gap-4">
//                     <div className="col-12 ps-2">
//                       <label htmlFor="">Description</label>
//                       <div className="no-drag">
//                         <CKEditor
//                           editor={ClassicEditor}
//                           disabled={modalType == "view"}
//                           onReady={(editor) => {}}
//                           data={description}
//                           onChange={(event, editor) => {
//                             if (modalType != "view") {
//                               const data = editor.getData();
//                               setDescription(data);
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </Form>
//             </Row>
//           </div>
//         </div>
//       </Row>
//     </div>
//   );
// });

const GeneralEditTaskTab = React.memo(function GeneralEditTaskTab({
  getLocations,
  generalData,
  tasks,
  alldependency,
  verticalActiveTab,
  onCloseEditModal,
  toggleLoading,
  updateData,
  modalType,
  relatedvalue,
}) {
  const [formRows, setFormRows] = useState([]);
  const [title, settitle] = useState(null);
  const [taskOption, setTaskOption] = useState([]);
  const [location, setLocation] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [assigned, setAssigned] = useState([]);
  const [est_time, setEstimatedTime] = useState([]);
  const [priority, setPriority] = useState([]);
  const [description, setDescription] = useState("");
  const [related_to, setRelatedTo] = useState([]);
  const [relatedId, setRelatedId] = useState([]);
  const [relatedOption, setRelatedOption] = useState([]);
  const [relatedSelected, setRelatedSelected] = useState([]);
  const [relatedIdOption, setRelatedIdOption] = useState([]);
  const [recurring, setRecurring] = useState(false);
  const [recurringType, setRecuringType] = useState(null);
  const [recurringDay, setRecurringDay] = useState(null);
  const [recurringDay1, setRecurringDay1] = useState(null);
  const [recurringEnd, setRecurringEnd] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tabType, setTabType] = useState("");
  const [initialDataSet, setInitialDataSet] = useState(false);

  const tapOption = [
    {
      value: 0,
      label: "General Tab",
    },
    {
      value: 1,
      label: "Personal Tab",
    },
  ];

  // =========================
  // RECURRING OPTIONS UPDATED
  // =========================
  const recurringTypeOptionsUpdated = [
    {
      value: "daily",
      label: "Daily",
    },
    {
      value: "weekly",
      label: "Weekly",
    },
    {
      value: "monthly",
      label: "Monthly",
    },
    {
      value: "3-monthly",
      label: "3 Monthly",
    },
    {
      value: "6-monthly",
      label: "6 Monthly",
    },
    {
      value: "yearly",
      label: "Yearly",
    },
  ];

  const dateOptions = Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: i + 1,
  }));

  const monthOptions = [
    { label: "January", value: 0 },
    { label: "February", value: 1 },
    { label: "March", value: 2 },
    { label: "April", value: 3 },
    { label: "May", value: 4 },
    { label: "June", value: 5 },
    { label: "July", value: 6 },
    { label: "August", value: 7 },
    { label: "September", value: 8 },
    { label: "October", value: 9 },
    { label: "November", value: 10 },
    { label: "December", value: 11 },
  ]

  // ======================================
  // AUTO CALCULATE START & END DATE
  // ======================================
  // useEffect(() => {
  //   if (!recurring || !recurringType?.value || !initialDataSet) return;

  //   const today = moment();

  //   // DAILY
  //   if (recurringType?.value === "daily") {
  //     setStartDate(today.format("YYYY-MM-DD"));
  //     setEndDate(today.format("YYYY-MM-DD"));
  //   }

  //   // WEEKLY
  //   else if (recurringType?.value === "weekly" && recurringDay?.length > 0) {
  //     const weekdays = {
  //       sunday: 0,
  //       monday: 1,
  //       tuesday: 2,
  //       wednesday: 3,
  //       thursday: 4,
  //       friday: 5,
  //       saturday: 6,
  //     };

  //     const selectedDays = recurringDay
  //       ?.map((d) => weekdays[d.value.toLowerCase()])
  //       ?.sort((a, b) => a - b);

  //     const currentDay = today.day();

  //     let nearestDay =
  //       selectedDays.find((d) => d >= currentDay) ?? selectedDays[0];

  //     let start = moment(today).day(nearestDay);

  //     if (nearestDay < currentDay) {
  //       start.add(1, "week");
  //     }

  //     let nextDayIndex =
  //       selectedDays.find((d) => d > nearestDay) ?? selectedDays[0];

  //     let nextDate = moment(start).day(nextDayIndex);

  //     if (nextDayIndex <= nearestDay) {
  //       nextDate.add(1, "week");
  //     }

  //     const end = moment(nextDate).subtract(1, "day");

  //     setStartDate(start.format("YYYY-MM-DD"));
  //     setEndDate(end.format("YYYY-MM-DD"));
  //   }

  //   // MONTHLY / 3 MONTHLY / 6 MONTHLY / YEARLY
  //   else if (
  //     ["monthly", "3-monthly", "6-monthly", "yearly"].includes(
  //       recurringType?.value,
  //     ) &&
  //     recurringDay1
  //   ) {
  //     const selectedDate = moment(recurringDay1);

  //     let duration = 1;

  //     if (recurringType?.value === "3-monthly") {
  //       duration = 3;
  //     }

  //     if (recurringType?.value === "6-monthly") {
  //       duration = 6;
  //     }

  //     if (recurringType?.value === "yearly") {
  //       duration = 12;
  //     }

  //     const end = moment(selectedDate)
  //       .add(duration, "months")
  //       .subtract(1, "day");

  //     setStartDate(selectedDate.format("YYYY-MM-DD"));
  //     setEndDate(end.format("YYYY-MM-DD"));
  //   }

  // }, [recurring, recurringType, recurringDay, recurringDay1]);

  // ======================================
  // AUTO CALCULATE START & END DATE
  // ======================================
  useEffect(() => {
    if (!recurring || !recurringType?.value || !initialDataSet) return;

    const today = moment();

    // DAILY
    if (recurringType?.value === "daily") {
      setStartDate(today.format("YYYY-MM-DD"));
      setEndDate(today.format("YYYY-MM-DD"));
    }

    // WEEKLY
    else if (recurringType?.value === "weekly" && recurringDay?.length > 0) {
      const weekdays = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
      };

      const selectedDays = recurringDay
        ?.map((d) => weekdays[d.value.toLowerCase()])
        ?.sort((a, b) => a - b);

      const currentDay = today.day();

      let nearestDay =
        selectedDays.find((d) => d >= currentDay) ?? selectedDays[0];

      let start = moment(today).day(nearestDay);

      if (nearestDay < currentDay) {
        start.add(1, "week");
      }

      let nextDayIndex =
        selectedDays.find((d) => d > nearestDay) ?? selectedDays[0];

      let nextDate = moment(start).day(nextDayIndex);

      if (nextDayIndex <= nearestDay) {
        nextDate.add(1, "week");
      }

      const end = moment(nextDate).subtract(1, "day");

      setStartDate(start.format("YYYY-MM-DD"));
      setEndDate(end.format("YYYY-MM-DD"));
    }

    // MONTHLY / 3-MONTHLY / 6-MONTHLY
    else if (
      ["monthly", "3-monthly", "6-monthly"].includes(recurringType?.value) &&
      recurringDay1
    ) {
      const selectedDay = parseInt(recurringDay1);

      let start = moment(today).date(selectedDay);

      // if selected date already passed in current month
      if (start.isBefore(today, "day")) {
        start.add(1, "month");
      }

      let duration = 1;

      if (recurringType?.value === "3-monthly") {
        duration = 3;
      }

      if (recurringType?.value === "6-monthly") {
        duration = 6;
      }

      const end = moment(start).add(duration, "months").subtract(1, "day");

      setStartDate(start.format("YYYY-MM-DD"));
      setEndDate(end.format("YYYY-MM-DD"));
    }

    // YEARLY
    else if (
      recurringType?.value === "yearly" &&
      recurringDay1?.month &&
      recurringDay1?.date
    ) {
      const selectedMonth = parseInt(recurringDay1.month);
      const selectedDate = parseInt(recurringDay1.date);

      let start = moment().month(selectedMonth).date(selectedDate);

      // if this year's date already passed
      if (start.isBefore(today, "day")) {
        start.add(1, "year");
      }

      const end = moment(start).add(1, "year").subtract(1, "day");

      setStartDate(start.format("YYYY-MM-DD"));
      setEndDate(end.format("YYYY-MM-DD"));
    }
  }, [recurring, recurringType, recurringDay, recurringDay1]);

  const onDeleteFormRow = (index) => {
    const newInputs = [...formRows];
    newInputs.splice(index, 1);
    setFormRows(newInputs);
  };

  const onAddFormRow = () => {
    setFormRows([
      ...formRows,
      { task_name: "", task_assign: null, task_status: 0, sub_enddate: "" },
    ]);
  };

  const handleInputChange = (key, event) => {
    const { name, value } = event?.target;
    const updatedFormRows = formRows.map((row, index) =>
      index === key ? { ...row, [name]: value } : row,
    );
    setFormRows(updatedFormRows);
  };

  const handleSelectChange = (key, selectedOption) => {
    const updatedFormRows = formRows.map((row, index) =>
      index === key ? { ...row, task_assign: selectedOption } : row,
    );
    setFormRows(updatedFormRows);
  };

  const handleEndChange = (key, e) => {
    const updatedFormRows = formRows.map((row, index) =>
      index === key ? { ...row, sub_enddate: e } : row,
    );
    setFormRows(updatedFormRows);
  };

  const handleCheckboxChange = (key) => {
    const updatedRows = formRows.map((person, index) => {
      if (index === key) {
        return {
          ...person,
          task_status: person.task_status === 1 ? 0 : 1,
        };
      }
      return person;
    });
    setFormRows(updatedRows);
  };

  useEffect(() => {
    setRecurring(generalData?.recurring == 1 ? true : false);

    setRecuringType(
      recurringTypeOptionsUpdated?.find(
        (obj) => obj?.value == generalData?.recurring_type,
      ),
    );

    setTabType(generalData?.tab_type);

    setRecurringEnd(generalData?.recurring_enddate);

    // ======================================
    // SET RECURRING DAYS INITIAL VALUES
    // ======================================

    // WEEKLY
    if (generalData?.recurring_type === "weekly") {
      const selectDay = generalData?.recurring_days?.split(",");

      setRecurringDay(
        daysOption?.filter((item) => selectDay?.includes(item.value)),
      );
    }

    // YEARLY
    else if (generalData?.recurring_type === "yearly") {
      const yearlyData = String(generalData?.recurring_days || "").split("-");

      setRecurringDay1({
        month: yearlyData?.[0] || "",
        date: yearlyData?.[1] || "",
      });
    }

    // MONTHLY / 3-MONTHLY / 6-MONTHLY
    else if (
      ["monthly", "3-monthly", "6-monthly"].includes(
        generalData?.recurring_type,
      )
    ) {
      setRecurringDay1(generalData?.recurring_days || "");
    }

    // DAILY
    else {
      setRecurringDay1("");
    }

    // setRecurringDay1(generalData?.recurring_days);

    const selectDay = generalData?.recurring_days?.split(",");

    setRecurringDay(
      daysOption?.filter((item) => selectDay?.includes(item.value)),
    );

    setLocation(
      getLocations?.find((loc) => loc.value == generalData?.location),
    );

    setStartDate(generalData?.startdate);

    setEndDate(generalData?.enddate);

    setDescription(generalData?.description || "");

    setPriority(
      priorityOption?.find((pro) => pro.value == generalData?.priorty),
    );

    const task = tasks?.find((obj) => obj.value == generalData?.title);

    settitle(generalData?.title);

    setTaskOption(tasks?.filter((obj) => obj?.related == generalData?.related));

    const ids = generalData?.assigned?.split(",").map(Number);

    const assignee = alldependency?.users?.filter((item) =>
      ids?.includes(item.value),
    );

    setAssigned(assignee);

    const relatedOption = RelatedToOption?.find(
      (rel) => rel.value == generalData?.related,
    );

    setRelatedSelected(relatedOption);

    setRelatedOption(relatedOption?.related);

    const realtedTo = relatedOption?.related?.find(
      (obj) => obj.value == generalData?.related_to,
    );

    setRelatedTo(realtedTo);

    setEstimatedTime(
      TimeOption?.find((obj) => obj.value == generalData?.estimate_time),
    );

    const relatedOptions =
      realtedTo?.value == "lead"
        ? alldependency?.leads
        : realtedTo?.value == "proposal"
        ? alldependency?.proposal
        : realtedTo?.value == "digital-project"
        ? alldependency?.digital_projects
        : realtedTo?.value == "development-project"
        ? alldependency?.projects
        : realtedTo?.value == "introducer"
        ? alldependency.introducer
        : realtedTo?.value == "staff"
        ? alldependency.staff
        : realtedTo?.value == "expense" || realtedTo?.value == "credit-card"
        ? alldependency?.expense
        : realtedTo?.value == "invoice"
        ? [...alldependency?.digital_projects, ...alldependency?.projects]
        : [];

    setRelatedIdOption(relatedOptions);

    setRelatedId(
      relatedOptions?.find((obj) => obj.value == generalData?.related_id),
    );

    if (generalData?.subtasks?.length == 0) {
      if (task != undefined && task?.subtasks != null) {
        const sub = task?.subtasks?.split("@#");

        setFormRows(
          sub?.map((obj) => ({
            task_name: obj,
            task_assign: null,
            task_status: 0,
            sub_enddate: "",
          })),
        );
      } else {
        setFormRows([]);
      }
    } else {
      setFormRows(
        generalData?.subtasks?.map((obj) => ({
          task_name: obj?.title,
          task_id: obj?.id,
          task_assign:
            alldependency?.users?.find((user) => user.value == obj?.assign) ||
            null,
          task_status: obj?.status,
          sub_enddate: obj?.enddate === "-" ? "" : obj?.enddate,
        })),
      );
    }
    console.log(generalData);
    setTimeout(() => setInitialDataSet(true), 2000);
  }, [generalData]);

  const onHandleEdit = async (e) => {
    e.preventDefault();

    // =========================================
    // BASIC VALIDATION
    // =========================================

    if (
      location == null ||
      title == null ||
      priority == null ||
      assigned?.length === 0
    ) {
      return Swal.fire({
        icon: "warning",
        text: "Please select all mandatory field.",
      });
    }

    // =========================================
    // RECURRING VALIDATION
    // =========================================

    if (recurring) {
      // recurring type required
      if (!recurringType?.value) {
        return Swal.fire({
          icon: "warning",
          text: "Please select recurring type.",
        });
      }

      // WEEKLY VALIDATION
      if (
        recurringType?.value === "weekly" &&
        (!recurringDay || recurringDay?.length === 0)
      ) {
        return Swal.fire({
          icon: "warning",
          text: "Please select recurring weekdays.",
        });
      }

      // MONTHLY / 3 MONTHLY / 6 MONTHLY VALIDATION
      if (
        ["monthly", "3-monthly", "6-monthly"].includes(recurringType?.value) &&
        !recurringDay1
      ) {
        return Swal.fire({
          icon: "warning",
          text: "Please select recurring date.",
        });
      }

      // YEARLY VALIDATION
      if (
        recurringType?.value === "yearly" &&
        (!recurringDay1 || !recurringDay1?.month || !recurringDay1?.date)
      ) {
        return Swal.fire({
          icon: "warning",
          text: "Please select recurring month and date.",
        });
      }
    }

    // =========================================
    // SUBTASK CHECK
    // =========================================

    const subtask_id = formRows?.some((item) => item.hasOwnProperty("task_id"));

    // =========================================
    // RECURRING DAYS VALUE
    // =========================================

    let recurringDaysValue = null;

    if (recurringType?.value === "weekly") {
      recurringDaysValue = recurringDay?.map((obj) => obj.value)?.join(",");
    } else if (
      ["monthly", "3-monthly", "6-monthly"].includes(recurringType?.value)
    ) {
      recurringDaysValue = recurringDay1;
    } else if (recurringType?.value === "yearly") {
      recurringDaysValue = `${recurringDay1?.month}-${recurringDay1?.date}`;
    }

    // =========================================
    // FORM DATA
    // =========================================

    const formDatas = {
      tab_type: tabType || 0,

      general_id: generalData?.id,

      user_id: localStorage.getItem("auth_id"),

      location: location?.value,

      title: title,

      startdate: startDate,

      enddate: endDate,

      assigned: assigned?.map((obj) => obj.value)?.join(","),

      priority: priority?.value,

      related: relatedSelected?.value,

      related_to: related_to?.value,

      related_id: relatedId?.value,

      est_time: est_time?.value,

      description: description,

      subtask: formRows?.map((obj) => obj?.task_name)?.join("@#"),

      subtask_assign: formRows
        ?.map((obj) => obj?.task_assign?.value)
        ?.join(","),

      subtask_status: formRows?.map((obj) => obj?.task_status)?.join(","),

      sub_enddate: formRows?.map((obj) => obj?.sub_enddate)?.join(","),

      edit_status: subtask_id ? 1 : 0,

      subtask_id: subtask_id
        ? formRows?.map((obj) => obj?.task_id)?.join(",")
        : "",

      recurring: recurring ? 1 : 0,

      recurring_type: recurring ? recurringType?.value : null,

      recurring_days: recurring ? recurringDaysValue : null,

      recurring_enddate: recurring ? recurringEnd : null,
    };

    // =========================================
    // API CALL
    // =========================================

    const response = await FetchNodePostData(
      toggleLoading,
      "editGeneralTasks",
      secureLocalStorage.getItem("auth_token"),
      formDatas,
    );

    if (response?.data?.success) {
      Swal.fire({
        icon: "success",
        text: "Task edited successfully.",
      }).then(() => {
        onCloseEditModal();

        updateData(response?.data?.data?.tasks[0], "edit");
      });
    }

    setLoading(false);
  };

  return (
    <div>
      {loading && <Loader />}

      <div className="text-end add-task-button d-flex gap-2 align-items-center">
        {localStorage?.getItem("auth_id") == 32 ||
        localStorage?.getItem("auth_id") == 1 ||
        localStorage?.getItem("auth_id") == 4 ? (
          <div className="me-5 radio-antd">
            <Radio.Group
              value={tabType}
              options={tapOption}
              onChange={(e) => {
                setTabType(e.target.value);
              }}
            />
          </div>
        ) : null}
        <h5 className="text-purple mb-0">
          Created by :{" "}
          <span className="text-primary">
            <strong>{generalData?.added_by_name}</strong>
          </span>
        </h5>
        {modalType != "view" && (
          <button
            type="submit"
            className="btn ms-md-2 btn-save btn-label"
            onClick={onHandleEdit}
          >
            <i className="fas fa-save me-1 label-icon"></i> Save
          </button>
        )}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            onCloseEditModal();
          }}
          className="btn ms-md-2 btn-red btn-label"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          CANCEL
        </button>
      </div>
      <Row>
        <div className="col-md-12 d-flex flex-column new-dashboard-task-modal bg-white">
          <div className="col-12 form-container mt-2">
            <Row className="bg-white px-2 py-4 shadow mb-3">
              <Form className="row d-flex justify-content-center align-items-center">
                <div className="col-md-12 d-flex flex-column new-task-modal">
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-sm-3 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Location <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Location"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        options={getLocations}
                        value={location}
                        onChange={(e) => setLocation(e)}
                        isDisabled={modalType == "view"}
                      />
                    </div>
                    <div className="col-md-9 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Task Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Enter Task Name"
                        value={title}
                        onChange={(e) => settitle(e.target.value)}
                        disabled={modalType == "view"}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-md-2 ps-2">
                      <Label>Start Date</Label>

                      <Input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        disabled={recurring || modalType == "view"}
                      />
                    </div>
                    <div className="col-md-2 ps-2">
                      <Label htmlFor="formrow-firstname-Input">End Date</Label>
                      <Input
                        type="date"
                        className="form-control"
                        placeholder="Select Date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        disabled={recurring || modalType == "view"}
                      />
                    </div>
                    <div className="col-md-2 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Estimated Time <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Time"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        options={TimeOption}
                        value={est_time}
                        onChange={(e) => setEstimatedTime(e)}
                        isDisabled={modalType == "view"}
                      />
                    </div>
                    <div className="col-md-6 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Assignee <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Member"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        isMulti
                        options={alldependency?.users}
                        value={assigned}
                        onChange={(e) => setAssigned(e)}
                        closeMenuOnSelect={false}
                        isDisabled={modalType == "view"}
                      />
                    </div>
                  </div>
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
                    <div className="col-md-3 ps-2">
                      <Label htmlFor="formrow-firstname-Input">
                        Priority <span className="text-danger">*</span>
                      </Label>
                      <Select
                        placeholder="Select Priority"
                        className="basic-multi-select"
                        classNamePrefix="select"
                        value={priority}
                        options={priorityOption}
                        onChange={(e) => setPriority(e)}
                        isDisabled={modalType == "view"}
                      />
                    </div>
                    {relatedOption?.length != 0 && (
                      <div className="col-md-2 ps-2">
                        <label htmlFor="sales-dropdown">
                          {relatedSelected?.label}
                        </label>
                        <Select
                          placeholder={`Select ${relatedSelected?.label}`}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={relatedOption}
                          value={related_to}
                          onChange={(selectedOption) => {
                            setRelatedTo(selectedOption);
                            const relatedOptions =
                              selectedOption?.value == "lead"
                                ? alldependency?.leads
                                : selectedOption?.value == "proposal"
                                ? alldependency?.proposal
                                : selectedOption?.value == "digital-project"
                                ? alldependency?.digital_projects
                                : selectedOption?.value == "development-project"
                                ? alldependency?.projects
                                : selectedOption?.value == "introducer"
                                ? alldependency.introducer
                                : selectedOption?.value == "staff"
                                ? alldependency.staff
                                : selectedOption?.value == "expense" ||
                                  selectedOption?.value == "credit-card"
                                ? alldependency?.expense
                                : selectedOption?.value == "invoice"
                                ? [
                                    ...alldependency?.digital_projects,
                                    ...alldependency?.projects,
                                  ]
                                : [];
                            setRelatedIdOption(relatedOptions);
                          }}
                          isDisabled={modalType == "view"}
                        />
                      </div>
                    )}
                    {relatedIdOption?.length != 0 && (
                      <div className="col-md-2 ps-2">
                        <label htmlFor="lead-dropdown">
                          {related_to?.label}
                        </label>
                        <Select
                          placeholder={`Select ${related_to?.label}`}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          options={relatedIdOption}
                          value={relatedId}
                          onChange={(e) => {
                            setRelatedId(e);
                          }}
                          isDisabled={modalType == "view"}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 d-flex mb-4 justify-content-start align-items-start">
                    <div className="col-md-2 mb-3">
                      <Label htmlFor="formrow-firstname-Input">
                        Recurring Task
                      </Label>
                      <div className="form-switch form-switch-md mb-2 ps-5">
                        <input
                          title="Recurring Task"
                          type="checkbox"
                          className="form-check-input"
                          id="customSwitchsizemd"
                          checked={recurring}
                          onChange={(e) => setRecurring(e.target.checked)}
                          disabled={modalType == "view"}
                        />
                      </div>
                    </div>
                    {recurring ? (
                      <>
                        <div className="col-md-3 ps-2">
                          <Label>
                            Recurring Type{" "}
                            <span className="text-danger">*</span>
                          </Label>

                          <Select
                            placeholder="Select Recurring Type"
                            className="basic-multi-select"
                            classNamePrefix="select"
                            options={recurringTypeOptionsUpdated}
                            value={recurringType}
                            onChange={(e) => setRecuringType(e)}
                            isDisabled={modalType == "view"}
                          />
                        </div>

                        {recurringType?.value == "weekly" ? (
                          <div className="col-md-5 ps-2">
                            <Label>
                              Select Days <span className="text-danger">*</span>
                            </Label>

                            <Select
                              placeholder="Select Days"
                              className="basic-multi-select"
                              classNamePrefix="select"
                              options={daysOption}
                              isMulti
                              value={recurringDay}
                              onChange={(e) => setRecurringDay(e)}
                              isDisabled={modalType == "view"}
                            />
                          </div>
                        ) : // [
                        //     "monthly",
                        //     "3-monthly",
                        //     "6-monthly",
                        //     "yearly",
                        //   ].includes(recurringType?.value) ? (
                        //   <div className="col-md-3 ps-2">
                        //     <Label>Select Date</Label>

                        //     <Input
                        //       type="date"
                        //       className="form-control"
                        //       value={recurringDay1}
                        //       onChange={(e) => setRecurringDay1(e.target.value)}
                        //       disabled={modalType == "view"}
                        //       min={moment().format("YYYY-MM-DD")}
                        //     />
                        //   </div>
                        // ) : null

                        [
                            "monthly",
                            "3-monthly",
                            "6-monthly",
                            "yearly",
                          ].includes(recurringType?.value) ? (
                          <>
                            {/* YEARLY */}
                            {recurringType?.value === "yearly" ? (
                              <>
                                <div className="col-md-2 ps-2">
                                  <Label>
                                    Select Date{" "}
                                    <span className="text-danger">*</span>
                                  </Label>

                                  <Select
                                    placeholder="Select Date"
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    options={dateOptions} 
                                    value={dateOptions?.find(
                                      (i) => i.value == recurringDay1.date,
                                    )}
                                    onChange={(e) =>
                                      setRecurringDay1({
                                        ...recurringDay1,
                                        date: e.value,
                                      })
                                    }
                                    isDisabled={modalType == "view"}
                                  />

                                  {/* <Input
                                    type="select"
                                    className="form-control"
                                    value={recurringDay1?.date || ""}
                                    onChange={(e) =>
                                      setRecurringDay1({
                                        ...recurringDay1,
                                        date: e.target.value,
                                      })
                                    }
                                    disabled={modalType == "view"}
                                    required
                                  >
                                    <option value="">Select Date </option>

                                    {Array.from({ length: 31 }, (_, i) => (
                                      <option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </option>
                                    ))}
                                  </Input> */}
                                </div>

                                <div className="col-md-2 ps-2">
                                  <Label>
                                    Select Month{" "}
                                    <span className="text-danger">*</span>
                                  </Label>

                                  <Select
                                    placeholder="Select Month"
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    options={monthOptions} 
                                    value={monthOptions?.find(
                                      (i) => i.value == recurringDay1?.month,
                                    )}
                                    onChange={(e) =>
                                      setRecurringDay1({
                                        ...recurringDay1,
                                        month: e.value,
                                      })
                                    }
                                    isDisabled={modalType == "view"}
                                  />

                                  {/* <Input
                                    type="select"
                                    className="form-control"
                                    value={recurringDay1?.month || ""}
                                    onChange={(e) =>
                                      setRecurringDay1({
                                        ...recurringDay1,
                                        month: e.target.value,
                                      })
                                    }
                                    disabled={modalType == "view"}
                                  >
                                    <option value="">Select Month</option>

                                    <option value="0">January</option>
                                    <option value="1">February</option>
                                    <option value="2">March</option>
                                    <option value="3">April</option>
                                    <option value="4">May</option>
                                    <option value="5">June</option>
                                    <option value="6">July</option>
                                    <option value="7">August</option>
                                    <option value="8">September</option>
                                    <option value="9">October</option>
                                    <option value="10">November</option>
                                    <option value="11">December</option>
                                  </Input> */}
                                </div>
                              </>
                            ) : (
                              /* MONTHLY / 3-MONTHLY / 6-MONTHLY */
                              <div className="col-md-2 ps-2">
                                <Label>
                                  Select Date{" "}
                                  <span className="text-danger">*</span>
                                </Label>

                                <Select
                                    placeholder="Select Date"
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    options={dateOptions} 
                                    value={dateOptions?.find(
                                      (i) => i.value == recurringDay1,
                                    )}
                                    onChange={(e) =>
                                      setRecurringDay1(e.value)
                                    }
                                    isDisabled={modalType == "view"}
                                  />

                                {/* <Input
                                  type="select"
                                  className="form-control"
                                  value={recurringDay1 || ""}
                                  onChange={(e) =>
                                    setRecurringDay1(e.target.value)
                                  }
                                  disabled={modalType == "view"}
                                >
                                  <option value="">Select Date</option>

                                  {Array.from({ length: 31 }, (_, i) => (
                                    <option key={i + 1} value={i + 1}>
                                      {i + 1}
                                    </option>
                                  ))}
                                </Input> */}
                              </div>
                            )}
                          </>
                        ) : null}

                        <div className="col-md-2 ps-2">
                          <Label>Recurring End Date</Label>

                          <Input
                            type="date"
                            className="form-control"
                            value={recurringEnd}
                            onChange={(e) => setRecurringEnd(e.target.value)}
                            disabled={modalType == "view"}
                          />
                        </div>
                      </>
                    ) : null}
                  </div>
                  {recurring && recurringType?.value == "daily" ? (
                    <div className="ps-2 text-danger mb-3">
                      *A new task will be assigned daily through this feature,
                      with the expectation that it will be completed on daily
                      purpose.
                    </div>
                  ) : recurring && recurringType?.value == "weekly" ? (
                    <div className="ps-2 text-danger mb-3">
                      * This feature will create tasks on the selected weekdays,
                      which are expected to be completed on selected weekdays
                    </div>
                  ) : recurring && recurringType?.value == "monthly" ? (
                    <div className="ps-2 text-danger mb-3">
                      * This feature will generate a new task every month on the
                      selected date, which need to be completed on selected
                      month day.
                    </div>
                  ) : null}

                  <div className="col-12 pe-2 form-container mt-2 ms-2">
                    <Row className="bg-white px-2 py-2 mt-0 shadow-md mb-3 me-5">
                      {modalType != "view" && (
                        <div className="d-flex justify-content-end align-items-end px-0 ms-3">
                          <div className="text-end mb-0">
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                onAddFormRow();
                              }}
                              className="btn btn-purple"
                            >
                              <i className="fas fa-plus me-2"></i>
                              Add Subtask
                            </button>
                          </div>
                        </div>
                      )}
                      {formRows?.map((person, key) => (
                        <div key={key} className="">
                          <div className="d-flex">
                            <div className="contact-form d-flex col-md-11">
                              <div className="custim-width contact-btns ml-10 d-flex justify-content-center align-items-center mb-md-0 mt-3">
                                <div className="text-end" id="customCheckbox">
                                  <input
                                    type="checkbox"
                                    className="form-check-input custom-checkbox mt-2"
                                    id={`customCheck-outlinecolor2-${key}`}
                                    checked={person?.task_status == 1}
                                    disabled={
                                      // generalData.added_by != localStorage.getItem("auth_id") ||
                                      person?.task_assign?.value !=
                                        localStorage.getItem("auth_id") ||
                                      modalType == "view"
                                    }
                                    onChange={() => handleCheckboxChange(key)}
                                  />
                                </div>
                              </div>
                              <div className="contact-column edit-contact-column mb-md-0 col-7">
                                <label htmlFor="">Subtask Name</label>
                                <input
                                  type="text"
                                  name="task_name"
                                  placeholder="Enter Subtask Name"
                                  className="form-control"
                                  value={person?.task_name}
                                  onChange={(e) => handleInputChange(key, e)}
                                  disabled={modalType == "view"}
                                />
                              </div>
                              <div className="contact-column edit-contact-column mb-md-0 col-3">
                                <label htmlFor="">Assignee</label>
                                <Select
                                  placeholder="Select Member"
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  name="task_assign"
                                  options={alldependency?.users}
                                  value={person?.task_assign}
                                  onChange={(selectedOption) =>
                                    handleSelectChange(key, selectedOption)
                                  }
                                  isDisabled={modalType == "view"}
                                />
                              </div>
                              <div className="contact-column edit-contact-column mb-md-0 col-2">
                                <label htmlFor="">End Date</label>
                                <input
                                  type="date"
                                  name="sub_enddate"
                                  className="form-control"
                                  value={person?.sub_enddate}
                                  onChange={(e) =>
                                    handleEndChange(key, e.target.value)
                                  }
                                  disabled={modalType == "view"}
                                />
                              </div>
                            </div>
                            <div className="col-md-1 contact-btns ml-10 d-flex justify-content-end align-items-end mb-md-0 ms-4">
                              <div className="text-end">
                                {modalType != "view" && (
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onDeleteFormRow(key);
                                    }}
                                    className="btn btn-red"
                                  >
                                    <i className="fas fa-trash-alt"></i>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                          {key !== formRows.length - 1 ? (
                            <div className="border-bottom my-3"></div>
                          ) : null}
                        </div>
                      ))}
                    </Row>
                  </div>

                  <div className="col-md-12 d-flex mb-0 justify-content-start align-items-end flex-column gap-4">
                    <div className="col-12 ps-2">
                      <label htmlFor="">Description</label>
                      <div className="no-drag">
                        <CKEditor
                          editor={ClassicEditor}
                          disabled={modalType == "view"}
                          onReady={(editor) => {}}
                          data={description}
                          onChange={(event, editor) => {
                            if (modalType != "view") {
                              const data = editor.getData();
                              setDescription(data);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </Row>
          </div>
        </div>
      </Row>
    </div>
  );
});

const EditTasks = ({
  generalData,
  tasks,
  alldependency,
  onCloseEditModal,
  toggleLoading,
  updateData,
  modalType,
  isLoading,
}) => {
  const [verticalActiveTab, setverticalActiveTab] = useState(
    RelatedToOption?.find((obj) => obj.value == generalData?.related)?.id,
  );
  const getLocations = useSelector((state) => state?.location?.locations);
  const [relatedvalue, setRelatedValue] = useState({});
  const roles = useSelector((state) => state?.Roles?.apiData);
  return (
    <div className="bg-white">
      {isLoading && <Loader />}
      <div className="modal-header mb-0">
        <div
          className="d-flex align-items-center justify-content-between"
          style={{ width: "100%" }}
        >
          <h5 className="col-6 modal-title mt-0">
            {modalType == "view" ? "View Activity" : "Edit Activity"}
          </h5>
        </div>
      </div>

      <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
        <Row className="gx-4 justify-content-between">
          <div className="side-tab h-100 py-3 bd-fixed-sidetab custom-Edit-Side">
            <Nav pills className="flex-column">
              {RelatedToOption?.map((obj, i) => {
                return (
                  <>
                    {checkPermissionsByModule(roles, obj?.role, 2) ? (
                      <NavItem key={i}>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classNames({
                            "mb-2": true,
                            active: verticalActiveTab === obj?.id,
                          })}
                          onClick={() => {
                            setverticalActiveTab(obj?.id);
                            setRelatedValue(obj);
                          }}
                          disabled={modalType == "view"}
                        >
                          {obj.label}
                        </NavLink>
                      </NavItem>
                    ) : null}
                  </>
                );
              })}
            </Nav>
          </div>
          <Col className="bd-right-side-tab custom-right-side">
            <div className="px-0 h-100 pl-0">
              <TabContent
                activeTab={verticalActiveTab}
                className="text-muted mt-4 mt-md-0"
              >
                {RelatedToOption?.map((obj, i) => {
                  return (
                    <TabPane tabId={obj.id} key={i}>
                      <GeneralEditTaskTab
                        getLocations={getLocations}
                        generalData={generalData}
                        tasks={tasks}
                        alldependency={alldependency}
                        verticalActiveTab={verticalActiveTab}
                        onCloseEditModal={onCloseEditModal}
                        toggleLoading={toggleLoading}
                        updateData={updateData}
                        modalType={modalType}
                        relatedvalue={relatedvalue}
                      />
                    </TabPane>
                  );
                })}
              </TabContent>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default React.memo(EditTasks);











// import classNames from "classnames";
// import React, { useEffect, useState } from "react";
// import {
//   Col,
//   Form,
//   Input,
//   Label,
//   Nav,
//   NavItem,
//   NavLink,
//   Row,
//   TabContent,
//   TabPane,
// } from "reactstrap";
// import Select from "react-select";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import {
//   daysOption,
//   priorityOption,
//   recurringTypeOptions,
//   RelatedToOption,
//   TimeOption,
// } from "utils/common-options";
// import { useSelector } from "react-redux";
// import Swal from "sweetalert2";
// import { FetchPostData } from "utils/common-fetchData";
// import secureLocalStorage from "react-secure-storage";
// import moment from "moment";
// import { checkPermissionsByModule } from "utils/common-helpers";
// import { Radio } from "antd";
// import Loader from "pages/Separate/Loader";

// const GeneralEditTaskTab = React.memo(function GeneralEditTaskTab({
//   getLocations,
//   generalData,
//   tasks,
//   alldependency,
//   verticalActiveTab,
//   onCloseEditModal,
//   toggleLoading,
//   updateData,
//   modalType,
//   relatedvalue,
// }) {
//   const [formRows, setFormRows] = useState([]);
//   const [title, settitle] = useState(null);
//   const [taskOption, setTaskOption] = useState([]);
//   const [location, setLocation] = useState(null);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [assigned, setAssigned] = useState([]);
//   const [est_time, setEstimatedTime] = useState([]);
//   const [priority, setPriority] = useState([]);
//   const [description, setDescription] = useState("");
//   const [related_to, setRelatedTo] = useState([]);
//   const [relatedId, setRelatedId] = useState([]);
//   const [relatedOption, setRelatedOption] = useState([]);
//   const [relatedSelected, setRelatedSelected] = useState([]);
//   const [relatedIdOption, setRelatedIdOption] = useState([]);
//   const [recurring, setRecurring] = useState(false);
//   const [recurringType, setRecuringType] = useState([]);
//   const [recurringDay, setRecurringDay] = useState([]);
//   const [recurringDay1, setRecurringDay1] = useState([]);
//   const [recurringEnd, setRecurringEnd] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [tabType, setTabType] = useState("");
//   const tapOption = [
//     {
//       value: 0,
//       label: "General Tab",
//     },
//     {
//       value: 1,
//       label: "Personal Tab",
//     },
//   ];

//   const onDeleteFormRow = (index) => {
//     const newInputs = [...formRows];
//     newInputs.splice(index, 1);
//     setFormRows(newInputs);
//   };

//   const onAddFormRow = () => {
//     setFormRows([
//       ...formRows,
//       { task_name: "", task_assign: null, task_status: 0, sub_enddate: "" },
//     ]);
//   };

//   const handleInputChange = (key, event) => {
//     const { name, value } = event?.target;
//     const updatedFormRows = formRows.map((row, index) =>
//       index === key ? { ...row, [name]: value } : row,
//     );
//     setFormRows(updatedFormRows);
//   };

//   const handleSelectChange = (key, selectedOption) => {
//     const updatedFormRows = formRows.map((row, index) =>
//       index === key ? { ...row, task_assign: selectedOption } : row,
//     );
//     setFormRows(updatedFormRows);
//   };

//   const handleEndChange = (key, e) => {
//     const updatedFormRows = formRows.map((row, index) =>
//       index === key ? { ...row, sub_enddate: e } : row,
//     );
//     setFormRows(updatedFormRows);
//   };

//   const handleCheckboxChange = (key) => {
//     const updatedRows = formRows.map((person, index) => {
//       if (index === key) {
//         return {
//           ...person,
//           task_status: person.task_status === 1 ? 0 : 1,
//         };
//       }
//       return person;
//     });
//     setFormRows(updatedRows);
//   };

//   useEffect(() => {
//     // Recurring
//     setRecurring(generalData?.recurring == 1 ? true : false);
//     setRecuringType(
//       recurringTypeOptions?.find(
//         (obj) => obj?.value == generalData?.recurring_type,
//       ),
//     );
//     setTabType(generalData?.tab_type);
//     setRecurringEnd(generalData?.recurring_enddate);
//     setRecurringDay1(generalData?.recurring_days);
//     const selectDay = generalData?.recurring_days?.split(",");
//     setRecurringDay(
//       daysOption?.filter((item) => selectDay?.includes(item.value)),
//     );

//     // General Data
//     setLocation(
//       getLocations?.find((loc) => loc.value == generalData?.location),
//     );
//     setStartDate(generalData?.startdate);
//     setEndDate(generalData?.enddate);
//     setDescription(generalData?.description || "");
//     setPriority(
//       priorityOption?.find((pro) => pro.value == generalData?.priorty),
//     );
//     const task = tasks?.find((obj) => obj.value == generalData?.title);
//     settitle(generalData?.title);
//     setTaskOption(tasks?.filter((obj) => obj?.related == generalData?.related));
//     const ids = generalData?.assigned?.split(",").map(Number);
//     const assignee = alldependency?.users?.filter((item) =>
//       ids?.includes(item.value),
//     );
//     setAssigned(assignee);
//     const relatedOption = RelatedToOption?.find(
//       (rel) => rel.value == generalData?.related,
//     );
//     setRelatedSelected(relatedOption);
//     setRelatedOption(relatedOption?.related);
//     const realtedTo = relatedOption?.related?.find(
//       (obj) => obj.value == generalData?.related_to,
//     );
//     setRelatedTo(realtedTo);
//     setEstimatedTime(
//       TimeOption?.find((obj) => obj.value == generalData?.estimate_time),
//     );
//     const relatedOptions =
//       realtedTo?.value == "lead"
//         ? alldependency?.leads
//         : realtedTo?.value == "proposal"
//         ? alldependency?.proposal
//         : realtedTo?.value == "digital-project"
//         ? alldependency?.digital_projects
//         : realtedTo?.value == "development-project"
//         ? alldependency?.projects
//         : realtedTo?.value == "introducer"
//         ? alldependency.introducer
//         : realtedTo?.value == "staff"
//         ? alldependency.staff
//         : realtedTo?.value == "expense" || realtedTo?.value == "credit-card"
//         ? alldependency?.expense
//         : realtedTo?.value == "invoice"
//         ? [...alldependency?.digital_projects, ...alldependency?.projects]
//         : [];
//     setRelatedIdOption(relatedOptions);
//     setRelatedId(
//       relatedOptions?.find((obj) => obj.value == generalData?.related_id),
//     );
//     if (generalData?.subtasks?.length == 0) {
//       if (task != undefined && task?.subtasks != null) {
//         // const sub = task?.subtasks?.split("#@");
//         const sub = task?.subtasks?.split("@#");
//         setFormRows(
//           sub?.map((obj) => ({
//             task_name: obj,
//             task_assign: null,
//             task_status: 0,
//             sub_enddate: "",
//           })),
//         );
//       } else {
//         setFormRows([]);
//       }
//     } else {
//       setFormRows(
//         generalData?.subtasks?.map((obj) => ({
//           task_name: obj?.title,
//           task_id: obj?.id,
//           task_assign:
//             alldependency?.users?.find((user) => user.value == obj?.assign) ||
//             null,
//           task_status: obj?.status,
//           sub_enddate: obj?.enddate === "-" ? "" : obj?.enddate,
//         })),
//       );
//     }
//   }, [generalData]);

//   useEffect(() => {
//     if (Object.keys(relatedvalue).length != 0) {
//       const related = RelatedToOption?.find(
//         (obj) => obj.id == verticalActiveTab,
//       );
//       setRelatedOption(related?.related);
//       setRelatedSelected(related);
//       setRelatedId([]);
//       setRelatedIdOption([]);
//       setRelatedTo([]);
//       setTaskOption(
//         tasks?.filter((obj) => obj?.related == relatedvalue?.value),
//       );
//       settitle([]);
//       setFormRows([]);
//     }
//   }, [relatedvalue]);

//   const onHandleEdit = async (e) => {
//     e.preventDefault();
//     const subtask_id = formRows?.some((item) => item.hasOwnProperty("task_id"));
//     const formDatas = {
//       tab_type: tabType || 0,
//       general_id: generalData?.id,
//       user_id: localStorage.getItem("auth_id"),
//       location: location?.value,
//       title: title,
//       startdate: startDate,
//       enddate: endDate,
//       assigned: assigned?.map((obj) => obj.value)?.join(","),
//       priority: priority?.value,
//       related: relatedSelected?.value,
//       related_to: related_to?.value,
//       related_id: relatedId?.value,
//       est_time: est_time?.value,
//       description: description,
//       subtask: formRows?.map((obj) => obj?.task_name)?.join("@#"),
//       subtask_assign: formRows
//         ?.map((obj) => obj?.task_assign?.value)
//         ?.join(","),
//       subtask_status: formRows?.map((obj) => obj?.task_status)?.join(","),
//       sub_enddate: formRows?.map((obj) => obj?.sub_enddate)?.join(","),
//       edit_status: subtask_id ? 1 : 0,
//       subtask_id: subtask_id
//         ? formRows?.map((obj) => obj?.task_id)?.join(",")
//         : "",
//       recurring: recurring ? 1 : 0,
//       recurring_type: recurringType?.value,
//       recurring_days:
//         recurringType?.value == "daily"
//           ? null
//           : recurringType?.value == "monthly"
//           ? moment(recurringDay1).format("DD")
//           : recurringType?.value == "weekly"
//           ? recurringDay?.map((obj) => obj.value)?.join(",")
//           : null,
//       recurring_enddate: recurringEnd,
//     };
//     const response = await FetchPostData(
//       toggleLoading,
//       "editGeneralTasks",
//       secureLocalStorage.getItem("auth_token"),
//       formDatas,
//     );
//     if (response?.data?.success) {
//       Swal.fire({
//         icon: "success",
//         text: "Task edited successfully.",
//       }).then(() => {
//         onCloseEditModal();
//         updateData(response?.data?.data);
//       });
//     }
//     setLoading(false);
//   };

//   console.log("generalData", generalData)

//   return (
//     <div>
//       {loading && <Loader />}

//       <div className="text-end add-task-button d-flex gap-2 align-items-center">
//         {localStorage?.getItem("auth_id") == 32 ||
//         localStorage?.getItem("auth_id") == 1 ||
//         localStorage?.getItem("auth_id") == 4 ? (
//           <div className="me-5 radio-antd">
//             <Radio.Group
//               value={tabType}
//               options={tapOption}
//               onChange={(e) => {
//                 setTabType(e.target.value);
//               }}
//             />
//           </div>
//         ) : null}
//         <h5 className="text-purple mb-0">
//           Created by :{" "}
//           <span className="text-primary">
//             <strong>{generalData?.added_by_name}</strong>
//           </span>
//         </h5>
//         {modalType != "view" && (
//           <button
//             type="submit"
//             className="btn ms-md-2 btn-save btn-label"
//             onClick={onHandleEdit}
//           >
//             <i className="fas fa-save me-1 label-icon"></i> Save
//           </button>
//         )}
//         <button
//           type="button"
//           onClick={(e) => {
//             e.preventDefault();
//             onCloseEditModal();
//           }}
//           className="btn ms-md-2 btn-red btn-label"
//         >
//           <i className="dripicons-cross me-2 icon-center label-icon"></i>
//           CANCEL
//         </button>
//       </div>
//       <Row>
//         <div className="col-md-12 d-flex flex-column new-dashboard-task-modal bg-white">
//           <div className="col-12 form-container mt-2">
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <Form className="row d-flex justify-content-center align-items-center">
//                 <div className="col-md-12 d-flex flex-column new-task-modal">
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                     <div className="col-sm-3 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Location <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Location"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         options={getLocations}
//                         value={location}
//                         onChange={(e) => setLocation(e)}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-9 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Task Name <span className="text-danger">*</span>
//                       </Label>
//                       <Input
//                         type="text"
//                         className="form-control"
//                         placeholder="Enter Task Name"
//                         value={title}
//                         onChange={(e) => settitle(e.target.value)}
//                         disabled={modalType == "view"}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                     <div className="col-md-2 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Start Date
//                       </Label>
//                       <Input
//                         type="date"
//                         className="form-control"
//                         placeholder="Select Date"
//                         value={startDate}
//                         onChange={(e) => setStartDate(e.target.value)}
//                         disabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-2 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">End Date</Label>
//                       <Input
//                         type="date"
//                         className="form-control"
//                         placeholder="Select Date"
//                         value={endDate}
//                         onChange={(e) => setEndDate(e.target.value)}
//                         disabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-2 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Estimated Time <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Time"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         options={TimeOption}
//                         value={est_time}
//                         onChange={(e) => setEstimatedTime(e)}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                     <div className="col-md-6 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Assignee <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Member"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         isMulti
//                         options={alldependency?.users}
//                         value={assigned}
//                         onChange={(e) => setAssigned(e)}
//                         closeMenuOnSelect={false}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-end">
//                     <div className="col-md-3 ps-2">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Priority <span className="text-danger">*</span>
//                       </Label>
//                       <Select
//                         placeholder="Select Priority"
//                         className="basic-multi-select"
//                         classNamePrefix="select"
//                         value={priority}
//                         options={priorityOption}
//                         onChange={(e) => setPriority(e)}
//                         isDisabled={modalType == "view"}
//                       />
//                     </div>
//                     {relatedOption?.length != 0 && (
//                       <div className="col-md-2 ps-2">
//                         <label htmlFor="sales-dropdown">
//                           {relatedSelected?.label}
//                         </label>
//                         <Select
//                           placeholder={`Select ${relatedSelected?.label}`}
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={relatedOption}
//                           value={related_to}
//                           onChange={(selectedOption) => {
//                             setRelatedTo(selectedOption);
//                             const relatedOptions =
//                               selectedOption?.value == "lead"
//                                 ? alldependency?.leads
//                                 : selectedOption?.value == "proposal"
//                                 ? alldependency?.proposal
//                                 : selectedOption?.value == "digital-project"
//                                 ? alldependency?.digital_projects
//                                 : selectedOption?.value == "development-project"
//                                 ? alldependency?.projects
//                                 : selectedOption?.value == "introducer"
//                                 ? alldependency.introducer
//                                 : selectedOption?.value == "staff"
//                                 ? alldependency.staff
//                                 : selectedOption?.value == "expense" ||
//                                   selectedOption?.value == "credit-card"
//                                 ? alldependency?.expense
//                                 : selectedOption?.value == "invoice"
//                                 ? [
//                                     ...alldependency?.digital_projects,
//                                     ...alldependency?.projects,
//                                   ]
//                                 : [];
//                             setRelatedIdOption(relatedOptions);
//                           }}
//                           isDisabled={modalType == "view"}
//                         />
//                       </div>
//                     )}
//                     {relatedIdOption?.length != 0 && (
//                       <div className="col-md-2 ps-2">
//                         <label htmlFor="lead-dropdown">
//                           {related_to?.label}
//                         </label>
//                         <Select
//                           placeholder={`Select ${related_to?.label}`}
//                           className="basic-multi-select"
//                           classNamePrefix="select"
//                           options={relatedIdOption}
//                           value={relatedId}
//                           onChange={(e) => {
//                             setRelatedId(e);
//                           }}
//                           isDisabled={modalType == "view"}
//                         />
//                       </div>
//                     )}
//                   </div>
//                   <div className="col-md-12 d-flex mb-4 justify-content-start align-items-start">
//                     <div className="col-md-2 mb-3">
//                       <Label htmlFor="formrow-firstname-Input">
//                         Recurring Task
//                       </Label>
//                       <div className="form-switch form-switch-md mb-2 ps-5">
//                         <input
//                           title="Recurring Task"
//                           type="checkbox"
//                           className="form-check-input"
//                           id="customSwitchsizemd"
//                           checked={recurring}
//                           onChange={(e) => setRecurring(e.target.checked)}
//                           disabled={modalType == "view"}
//                         />
//                       </div>
//                     </div>
//                     {recurring ? (
//                       <>
//                         <div className="col-md-3 ps-2">
//                           <Label htmlFor="formrow-firstname-Input">
//                             Recurring Type
//                           </Label>
//                           <Select
//                             placeholder="Select Recurring Type"
//                             className="basic-multi-select"
//                             classNamePrefix="select"
//                             options={recurringTypeOptions}
//                             value={recurringType}
//                             onChange={(e) => setRecuringType(e)}
//                             isDisabled={modalType == "view"}
//                           />
//                         </div>
//                         {recurringType?.value == "weekly" ? (
//                           <div className="col-md-5 ps-2">
//                             <Label htmlFor="formrow-firstname-Input">
//                               Select Days
//                             </Label>
//                             <Select
//                               placeholder="Select Days"
//                               className="basic-multi-select"
//                               classNamePrefix="select"
//                               options={daysOption}
//                               isMulti
//                               value={recurringDay}
//                               onChange={(e) => setRecurringDay(e)}
//                               isDisabled={modalType == "view"}
//                             />
//                           </div>
//                         ) : recurringType?.value == "monthly" ? (
//                           <div className="col-md-3 ps-2">
//                             <Label htmlFor="formrow-firstname-Input">
//                               Select Date
//                             </Label>
//                             <Input
//                               type="date"
//                               className="form-control"
//                               placeholder="Select Date"
//                               value={recurringDay1}
//                               onChange={(e) => setRecurringDay1(e.target.value)}
//                               disabled={modalType == "view"}
//                             />
//                           </div>
//                         ) : null}
//                         <div className="col-md-2 ps-2">
//                           <Label htmlFor="formrow-firstname-Input">
//                             Recurring End Date
//                           </Label>
//                           <Input
//                             type="date"
//                             className="form-control"
//                             placeholder="Select Date"
//                             value={recurringEnd}
//                             onChange={(e) => setRecurringEnd(e.target.value)}
//                             disabled={modalType == "view"}
//                           />
//                         </div>
//                       </>
//                     ) : null}
//                   </div>
//                   {recurring && recurringType?.value == "daily" ? (
//                     <div className="ps-2 text-danger mb-3">
//                       *A new task will be assigned daily through this feature,
//                       with the expectation that it will be completed on daily
//                       purpose.
//                     </div>
//                   ) : recurring && recurringType?.value == "weekly" ? (
//                     <div className="ps-2 text-danger mb-3">
//                       * This feature will create tasks on the selected weekdays,
//                       which are expected to be completed on selected weekdays
//                     </div>
//                   ) : recurring && recurringType?.value == "monthly" ? (
//                     <div className="ps-2 text-danger mb-3">
//                       * This feature will generate a new task every month on the
//                       selected date, which need to be completed on selected
//                       month day.
//                     </div>
//                   ) : null}
//                   <div className="col-md-12 d-flex mb-0 justify-content-start align-items-end flex-column gap-4">
//                     <div className="col-12 ps-2">
//                       <label htmlFor="">Description</label>
//                       <div className="no-drag">
//                         <CKEditor
//                           editor={ClassicEditor}
//                           disabled={modalType == "view"}
//                           onReady={(editor) => {}}
//                           data={description}
//                           onChange={(event, editor) => {
//                             if (modalType != "view") {
//                               const data = editor.getData();
//                               setDescription(data);
//                             }
//                           }}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-12 pe-2 form-container mt-2 ms-2">
//                     <Row className="bg-white px-2 py-2 mt-0 shadow-md mb-3 me-5">
//                       {modalType != "view" && (
//                         <div className="d-flex justify-content-end align-items-end px-0 ms-3">
//                           <div className="text-end mb-0">
//                             <button
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 onAddFormRow();
//                               }}
//                               className="btn btn-purple"
//                             >
//                               <i className="fas fa-plus me-2"></i>
//                               Add Subtask
//                             </button>
//                           </div>
//                         </div>
//                       )}
//                       {formRows?.map((person, key) => (
//                         <div key={key} className="">
//                           <div className="d-flex">
//                             <div className="contact-form d-flex col-md-11">
//                               <div className="custim-width contact-btns ml-10 d-flex justify-content-center align-items-center mb-md-0 mt-3">
//                                 <div className="text-end" id="customCheckbox">
//                                   <input
//                                     type="checkbox"
//                                     className="form-check-input custom-checkbox mt-2"
//                                     id={`customCheck-outlinecolor2-${key}`}
//                                     checked={person?.task_status == 1}
//                                     disabled={
//                                       // generalData.added_by != localStorage.getItem("auth_id") ||
//                                       person?.task_assign?.value !=
//                                         localStorage.getItem("auth_id") ||
//                                       modalType == "view"
//                                     }
//                                     onChange={() => handleCheckboxChange(key)}
//                                   />
//                                 </div>
//                               </div>
//                               <div className="contact-column edit-contact-column mb-md-0 col-7">
//                                 <label htmlFor="">Subtask Name</label>
//                                 <input
//                                   type="text"
//                                   name="task_name"
//                                   placeholder="Enter Subtask Name"
//                                   className="form-control"
//                                   value={person?.task_name}
//                                   onChange={(e) => handleInputChange(key, e)}
//                                   disabled={modalType == "view"}
//                                 />
//                               </div>
//                               <div className="contact-column edit-contact-column mb-md-0 col-3">
//                                 <label htmlFor="">Assignee</label>
//                                 <Select
//                                   placeholder="Select Member"
//                                   className="basic-multi-select"
//                                   classNamePrefix="select"
//                                   name="task_assign"
//                                   options={alldependency?.users}
//                                   value={person?.task_assign}
//                                   onChange={(selectedOption) =>
//                                     handleSelectChange(key, selectedOption)
//                                   }
//                                   isDisabled={modalType == "view"}
//                                 />
//                               </div>
//                               <div className="contact-column edit-contact-column mb-md-0 col-2">
//                                 <label htmlFor="">End Date</label>
//                                 <input
//                                   type="date"
//                                   name="sub_enddate"
//                                   className="form-control"
//                                   value={person?.sub_enddate}
//                                   onChange={(e) =>
//                                     handleEndChange(key, e.target.value)
//                                   }
//                                   disabled={modalType == "view"}
//                                 />
//                               </div>
//                             </div>
//                             <div className="col-md-1 contact-btns ml-10 d-flex justify-content-end align-items-end mb-md-0 ms-4">
//                               <div className="text-end">
//                                 {modalType != "view" && (
//                                   <button
//                                     onClick={(e) => {
//                                       e.preventDefault();
//                                       onDeleteFormRow(key);
//                                     }}
//                                     className="btn btn-red"
//                                   >
//                                     <i className="fas fa-trash-alt"></i>
//                                   </button>
//                                 )}
//                               </div>
//                             </div>
//                           </div>
//                           {key !== formRows.length - 1 ? (
//                             <div className="border-bottom my-3"></div>
//                           ) : null}
//                         </div>
//                       ))}
//                     </Row>
//                   </div>
//                 </div>
//               </Form>
//             </Row>
//           </div>
//         </div>
//       </Row>
//     </div>
//   );
// });

// const EditTasks = ({
//   generalData,
//   tasks,
//   alldependency,
//   onCloseEditModal,
//   toggleLoading,
//   updateData,
//   modalType,
//   isLoading,
// }) => {
//   const [verticalActiveTab, setverticalActiveTab] = useState(
//     RelatedToOption?.find((obj) => obj.value == generalData?.related)?.id,
//   );
//   const getLocations = useSelector((state) => state?.location?.locations);
//   const [relatedvalue, setRelatedValue] = useState({});
//   const roles = useSelector((state) => state?.Roles?.apiData);
//   return (
//     <div className="bg-white">
//       {isLoading && <Loader />}
//       <div className="modal-header mb-0">
//         <div
//           className="d-flex align-items-center justify-content-between"
//           style={{ width: "100%" }}
//         >
//           <h5 className="col-6 modal-title mt-0">
//             {modalType == "view" ? "View Activity" : "Edit Activity"}
//           </h5>
//         </div>
//       </div>

//       <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
//         <Row className="gx-4 justify-content-between">
//           <div className="side-tab h-100 py-3 bd-fixed-sidetab custom-Edit-Side">
//             <Nav pills className="flex-column">
//               {RelatedToOption?.map((obj, i) => {
//                 return (
//                   <>
//                     {checkPermissionsByModule(roles, obj?.role, 2) ? (
//                       <NavItem key={i}>
//                         <NavLink
//                           style={{ cursor: "pointer" }}
//                           className={classNames({
//                             "mb-2": true,
//                             active: verticalActiveTab === obj?.id,
//                           })}
//                           onClick={() => {
//                             setverticalActiveTab(obj?.id);
//                             setRelatedValue(obj);
//                           }}
//                           disabled={modalType == "view"}
//                         >
//                           {obj.label}
//                         </NavLink>
//                       </NavItem>
//                     ) : null}
//                   </>
//                 );
//               })}
//             </Nav>
//           </div>
//           <Col className="bd-right-side-tab custom-right-side">
//             <div className="px-0 h-100 pl-0">
//               <TabContent
//                 activeTab={verticalActiveTab}
//                 className="text-muted mt-4 mt-md-0"
//               >
//                 {RelatedToOption?.map((obj, i) => {
//                   return (
//                     <TabPane tabId={obj.id} key={i}>
//                       <GeneralEditTaskTab
//                         getLocations={getLocations}
//                         generalData={generalData}
//                         tasks={tasks}
//                         alldependency={alldependency}
//                         verticalActiveTab={verticalActiveTab}
//                         onCloseEditModal={onCloseEditModal}
//                         toggleLoading={toggleLoading}
//                         updateData={updateData}
//                         modalType={modalType}
//                         relatedvalue={relatedvalue}
//                       />
//                     </TabPane>
//                   );
//                 })}
//               </TabContent>
//             </div>
//           </Col>
//         </Row>
//       </div>
//     </div>
//   );
// };

// export default React.memo(EditTasks);